import React from 'react';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { Tag } from 'components/Tag';
import { Image } from 'components/Image/Image';
import { Button } from 'components/form/Button';
import { openNewTab } from 'helpers/domHelper';
import { useEventHandler } from 'hook/event.hook';
import { useSeenModulePixel } from 'hook/helper.hook';
import { CLICK } from 'externals/_tracking/types/eventTypes.constants';
import { BANKING_VERTICAL } from 'types/mrph.vertical.constants';
import './MobileDeviceProtection.scss';
import { useConfig } from 'hook/config.hook';

const MobileDeviceProtection = props => {
  const eventHandler = useEventHandler();
  const { config } = useConfig();
  const pixel = useSeenModulePixel({
    'Module Name': 'Mastercard Mobile Device Protection',
  });
  const onClickMobileProtectionTerms = () => {
    eventHandler(CLICK, {
      'Click Type': 'Click Mobile Device Terms and Conditions',
      Vertical: BANKING_VERTICAL,
    });
    openNewTab(config?.mobileDeviceProtection?.mastercardCardholders);
  };
  const onClickMobileProtectionClaim = () => {
    eventHandler(CLICK, {
      'Click Type': 'Make Mobile Device Claim',
      Vertical: BANKING_VERTICAL,
    });
    openNewTab('https://www.mycardbenefits.com/');
  };

  return (
    <div className="format50 m-format100 margTB8 padR8 m-padR0">
      {pixel}
      <FlexContainer className="flex-column align-items-center pad24 bgWhite">
        <div className="text-left format100 padB8 flex-ord-1">
          <Tag extClass="inblock" backgroundClass="bgYellow075">
            FREE
          </Tag>
        </div>
        <div
          data-testid="mobile-protection-title"
          className="text-28 bold m-text-20 flex-ord-2 padTB8"
        >
          Mobile device protection up to $500 a year
        </div>
        <FlexContainer className="align-items-center justify-center flex-ord-3 m-flex-ord-4 padTB8 mobileDevice">
          <Image imgClass="mobileDeviceProtection" />
        </FlexContainer>
        <div className="text-16 fontGray500  flex-ord-4 m-flex-ord-3 padTB12 m-padTB8 ">
          You’ll get up to $500 to replace or repair your phone if it’s stolen
          or damaged. Pay your eligible monthly mobile bill with Sesame Cash and
          you’re automatically covered!
        </div>
        <FlexContainer className="flex-row flex-tablet-col format100 flex-ord-5 padTB12 m-padTB8  justify-between">
          <Button
            mrphType="link"
            className="flex-ord-1 m-flex-ord-2"
            onClick={onClickMobileProtectionTerms}
            datatestid="mobile-protection-tc"
          >
            Terms & Conditions
          </Button>
          <Button
            mrphType="primary"
            onClick={onClickMobileProtectionClaim}
            className="flex-ord-2 m-flex-ord-1 margB0 m-margB16"
            datatestid="mobile-protection-make-claim"
          >
            Make a Claim
          </Button>
        </FlexContainer>
      </FlexContainer>
    </div>
  );
};

export default MobileDeviceProtection;
